<template>
  <div>
    <!-- <div :style="'height:550px;width: 100%;z-index: 2;position: absolute;opacity: 0.71;background-image: linear-gradient(180deg, #000000 0%, rgba(1,1,0,0.88) 15%, rgba(8,7,1,0.00) 100%);'"></div> -->
    <div class="channel__wrapper">
      <div class="channel__inner">
        <div class="channel-img__wrapper">
          <img style="width:100%;" class="smallImg" src="./../assets/img/img_bg5_meeting.png" alt="">
          <img style="width:100%;" class="bigImg" src="http://www.lvshouhotel.com/lvshouhotel/1565691037569_img_bg_meeting.png" alt="">
        </div>
      </div>
    </div>
    <div class="box brand">
      
      <div class="box-title">
        <img class="" src="./../assets/img/icon_meeting_banquet.png" alt="">
      </div>
      <!-- <div class="title-en ta_c">Conference and Banquet</div>
      <div class="title ta_c">会议与宴会</div> -->
      <div class="brand__inner">
        <p>酒店拥有能同时容纳600人的无柱豪华宴会厅、9间不同规格大小的 会议室。豪华典雅的装饰，高新的音、视频、同声翻译</p>
        <p>系统设备，是您举办各种规模会议、展示会、大型活动及婚礼的最佳场所，专业宴会服务团队定能带给您不同寻常的商务休</p>
        <p style="margin-bottom: 50px">闲之旅。</p>
        <img class="fl" src="http://www.lvshouhotel.com/lvshouhotel/img_meetings_banquet.png" alt=""> 
        <div class="fr brand__wrapper">
          <ul>
            <li style="margin-top: 5px;"><span>10种大小各异的会议室、多功能厅全面满足各种规模的商</span><br> <span style="margin-left: 19px;">务和休闲活动。</span></li>
            <li>先进音响视听设备，高速光纤网络入口及投影投射屏幕。</li>
            <li>电话会议系统、视频会议系统、同声翻译全面化系统。</li>
            <li>专业化会议服务人员为您提供高水准的“一站式”服务体<br><span style="margin-left: 19px;">验。</span></li>
            <li>将您每一次的会议与宴会交给我们策划，能助您打造愉快<br><span style="margin-left: 19px;">与充满成效的难忘活动体验。</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="box brand">
      <div class="box-title">
        <img class="" src="./../assets/img/icon_wedding_banquet.png" alt="">
      </div>
      <!-- <div class="title-en ta_c">Wedding banquet and celebration</div>
      <div class="title ta_c">婚宴与庆典</div> -->
      <div class="brand__inner">
        <div class="fl brand__wrapper Wedding">
          <ul>
            <li style="margin-top: 0px;">一生中重要的活动必须令人终生难忘。</li>
            <li>在绿瘦酒店，由我们照料活动的整体体验，而您只需尽享<br><span style="margin-left: 19px;">美好时光。</span></li>
            <li>我们充满热情的活动策划专家经过悉心培训。</li>
            <li>根据您的喜好，对活动的每一个细节进行策划与定制。</li>
            <li>从优美的环境与一应俱全的商业设备到卓越的服务与独特<br><span style="margin-left: 19px;">的体验。</span></li>
            <li>我们在此协助您关注每一个细枝末节，打造成功庆典。</li>
            <li>绿瘦酒店将是您婚宴、会宴的不二之选</li>
          </ul>
        </div>
        <img class="fr" src="http://www.lvshouhotel.com/lvshouhotel/img_weddings_banquet.png" alt=""> 
      </div>
    </div>
    <div class="place">
      <div class="title ta_c">会议场地</div>
      <div class="line"></div>
      <div class="item o_v" v-for="(item, index) in placeList" :key="index" v-show="index >= minIndex && index < maxIndex">
        <img class="fl" :src="item.url" alt="">
        <div class="fr item_desc">
          <h2>{{item.name}}</h2>
          <ul class="o_v data">
            <li>面积{{item.area}}m²</li>
            <li>容纳人数{{item.people}}人</li>
            <li>位于{{item.floor}}层</li>
            <li>长宽{{item.length}}*{{item.width}}m</li>
            <li>层高{{item.height}}m</li>
            <li>灯下高度{{item.lightUheight}}m</li>
          </ul>
          <ul class="o_v device" v-if="item.setUp">
            <li>支持摆台：</li>
            <li v-for="row in item.setUp">{{row}}</li>
          </ul>
          <ul class="o_v device" v-if="item.deviceList">            
            <li>配音设施：</li>
            <li v-for="row in item.deviceList">{{row}}</li>
          </ul>
          <div class="tags">
            <span v-for="row in item.tags">{{row}}</span>
          </div>
          <a v-if="item.imgUrl" :href="item.imgUrl" download="logo.png" class="btn fr">
    　　    下载平面图
          </a>
          <button class="btn-on fr" @click="xunjia()">询价</button>
        </div>
      </div>
      <div class="line" style="margin-bottom: 20px;"></div>
      <div class="fenye ta_r">
        <span class="fenye-item ta_c" @click="changeData(index)" :class="pagesize == index ? 'fenye-active':''" v-for="(item,index) in placeList.length" v-show="index < Math.ceil(placeList.length/6)" :key="index">{{index*1 +1}}</span>
      </div>
      
    </div>
  </div>
</template>
<script>
import place from "@/assets/json/place"
export default {
  data(){
    return {
      pagesize:0,
      minIndex:0,
      maxIndex:6,
      placeList: place
    }
  },
  mounted() {
  },
  methods: {
    changeData(val){
      this.pagesize = val;
      this.minIndex = 6 * (val * 1);
      this.maxIndex = 6 * (val * 1 + 1);
    },
    xunjia(){
        window.open('https://www.huixiaoer.com/view/hotel-86121508')
    }
  }
}
</script>
<style lang="less" scoped>
.channel__wrapper{
  background: #000;
  min-height: 550px;
  .channel-img__wrapper {
    background: #000;
    position: absolute;
    width: 1920px;
    min-height: 550px;
    left: 50%;
    margin-left: -960px;
    img{
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -960px;
    }
    
  }
  .channel__inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      min-height: 550px;
      min-width: 1244px;
    }
}
.box{
  padding: 100px 0 0;
  margin-top: 50px;
  .box-title{
    img{
      margin: 0 auto;
      display: block;
    }
  }
  .title{
    font-size: 36px;
    color: #584339;
    letter-spacing: 5px;
    margin-top: 10px;
    min-width: 1244px;
  }
  .title-en{
    opacity: 0.46;
    font-size: 64px;
    color: #D3CBB7;
    letter-spacing: 0;
    font-family: "宋体";
    font-weight: bold;
    min-width: 1244px;
  }
  h3{
    font-size: 20px;
    color: #333333;
    letter-spacing: 2px;
    line-height: 40px;
  }
  .btn{
    border: 1px solid #B99740;
    width: 285px;
    height: 60px;
    color: #B99740;
    font-size: 18px;
    background: #ffffff;
    display: block;
    margin: 0 auto;
  }
}
.brand{
  
  .brand__inner{
    width: 966px;
    margin: 85px auto 0;
    overflow: hidden;
    p{
      width: 966px;
      margin: 0 auto;
      font-size: 16px;
      color: #333333;
      letter-spacing: 1.8px;
      line-height: 40px;
    }
    .brand__wrapper{
      width: 391px;
      h1{
        font-size: 30px;
        color: #333333;
        letter-spacing: 5px;
        margin-bottom: 30px;
      }
      
      ul{
        margin: 10px 0 10px 0px;
        li{
          font-size: 14px;
          color: #666666;
          letter-spacing: 0.7px;
          // list-style-type: disc;
          line-height: 24px;
          margin: 25px 0;
        }
        li::before{
          display: inline-block;
          content: " ";
          width: 6px;
          height: 6px;
          background: #DEDAD8;
          border-radius: 50%;
          margin-right: 14px;
        }
      }
    }
    .Wedding{
      li{
        margin: 20px 0!important;
      }
      li:first-child{
        margin-top: 0!important;
      }
    }
  }
}
.place{
  padding: 100px 0 0;
  margin-top: 50px;
  .title{
    font-size: 30px;
    color: #333333;
    letter-spacing: 0;
  }
  .line{
    width: 1133px;
    height: 3px;
    background: #D8D8D8;
    opacity: 0.24;
    margin: 40px auto 60px;
  }
  .item{
    width: 1133px;
    margin: 0 auto 70px;
    h2{
      font-size: 20px;
      color: #333333;
      letter-spacing: 1px;
    }
    
    ul.device{
      margin-top: 14px;
      li{
        float: left;
        font-size: 14px;
        color: #666666;
        letter-spacing: 1px;
      }
      li+li{
        margin-left: 20px;
      }
    }
    ul.data{
      margin: 14px 0;
      li{
        float: left;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0.8px;
        line-height: 21px;
      }
      
      li:not(:first-child):before{
        content: "|";
        color: #E0E0E0;
        margin: 0 10px;
      }
    }
    .tags{
      margin-top: 14px;
      span{
        display: inline-block;
        border: 1px solid #E6E6E6;
        height: 24px;
        line-height: 24px;
        padding: 0 5px;
        font-size: 13px;
        color: #999999;
        letter-spacing: 0.93px;
        
      }
      span+span{
        margin-left: 10px;
      }
      
    }
    .btn, .btn-on{
      border: 1px solid #e8dbb9;
      font-size: 14px;
      color: #BCA15B;
      letter-spacing: 1px;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      display: block;
      margin: 0 auto;
      margin-top: 24px;
      margin-left: 40px;
      cursor: pointer;
    }
    .btn-on{
      opacity: 1;
      background: #BCA15B;
      color: #FFFFFF;
      font-size: 16px;
    }
  }
  .item_desc{
    width: 717px;
  }
}
.fenye{
  width: 1133px;
  margin: 0 auto 180px;
}
</style>


